import { useMutation, useQueryClient } from "react-query";
import authAPI from "../authAPI";

export const useRemoveGroupMember = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ groupId, memberId }) =>
      authAPI.removeGroupMember(groupId, memberId),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(["groupMembers", variables.groupId]);
        queryClient.invalidateQueries(["group"]);
      },
      onError: (error) => {
        console.error("Error while removing group member:", error);
      },
    }
  );
};
